export default function ClusterBand({ clusterIndex, clusterName }: { clusterIndex: number; clusterName: string }) {
  return (
    <div className="flex items-baseline gap-3 py-4 border-b border-border mb-8">
      <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
        Cluster {clusterIndex + 1}
      </span>
      <span className="font-display italic text-lg text-foreground [font-variation-settings:'opsz'_96,'SOFT'_80]">
        {clusterName}
      </span>
    </div>
  );
}
